export function isSpecialProfileType(profileType?: string | null): boolean {
  return profileType === 'Community' || profileType === 'Event';
}

export function canUseDiscover(profileType?: string | null): boolean {
  return !isSpecialProfileType(profileType);
}

const IDENTITY_REQUIRED_LOOKING_FOR = new Set([
  'Long-term relationship',
  'Short-term dating',
  'Exploring'
]);

export function requiresIdentitySelections(lookingFor?: string[] | string | null): boolean {
  if (!lookingFor) {
    return false;
  }

  const selections = Array.isArray(lookingFor)
    ? lookingFor
    : lookingFor.split(/[,;]+/);

  return selections.some((option) => IDENTITY_REQUIRED_LOOKING_FOR.has(option.trim()));
}
